__turbopack_context__.v({
  "mapPromoBlock": "styles-module__vpyhLq__mapPromoBlock",
});
